import { makeStyles } from "@material-ui/styles";

export const spinnerStyles = {
  wrapper: (base : any) => ({
    ...base,
    position: "static",
  }),
  overlay: (base : any) => ({
    ...base,
    background: "rgba(0, 0, 0, 0.2)",
  }),
};

export default makeStyles({
  circularProgress: {
    display: "flex",
    height: "-webkit-fill-available",
    justifyContent: "center",
    alignItems: "center",
  },

  title: {
    marginTop: 200,
    color: "#212529",
    fontSize: "1.75rem",
  },

  description: {
    paddingTop: "1.5rem",
    paddingBottom: "2rem",
  },
});
